import { makeStyles } from "@material-ui/core/styles";
import { COLORS } from "../../constants/colors";

export default makeStyles((theme) => ({
  title: {
    textDecoration: "underline",
    fontFamily: "Montserrat",
  },
  font: {
    color: `${COLORS.accent}`,
  },
  link: {
    color: `${COLORS.accent}`,
    "&:hover": {
      color: `${COLORS.accent}`,
    },
  },
  mainTitle: {
    textDecoration: "underline",
    textAlign: "center",
    marginBottom: "1rem",
    fontFamily: "Montserrat",
  },
  paragraph: {
    marginBottom: "1rem",
    fontFamily: "Blinker",
    fontSize: "20px",
  },
  listItem: {
    fontFamily: "Blinker",
    fontSize: "20px",
  },
}));
